var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.9,
    height: 9.9
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".remove-small_svg__cls-1{fill:#8e8e95}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove-small_svg__Group_676",
    "data-name": "Group 676",
    transform: "translate(-832.084 -245.136)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "remove-small_svg__Rectangle_623",
    "data-name": "Rectangle 623",
    className: "remove-small_svg__cls-1",
    width: 12,
    height: 2,
    rx: 1,
    transform: "rotate(-135 473.104 -46.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "remove-small_svg__Rectangle_626",
    "data-name": "Rectangle 626",
    className: "remove-small_svg__cls-1",
    width: 12,
    height: 2,
    rx: 1,
    transform: "rotate(-45 722.19 -877.604)"
  }))));
}
export default SvgRemoveSmall;